import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { offer } from '../data/offer';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <div className="sticky top-0 z-50 w-full border-b border-[#8f1f0f] bg-clay text-bone" data-id="element-122" data-mp="37uie591pzani">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-x-6 gap-y-2 px-4 py-2.5 sm:flex-row sm:justify-between" data-id="element-123" data-mp="32wgscgcwsx8c">
        <p className="flex items-start gap-2 text-[13px] leading-snug sm:items-center" data-id="element-124" data-mp="2yx80xi5cdbfy">
          <AlertTriangleIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" data-id="element-125" data-mp="2u2lm1501x0r4" />
          <span data-id="element-126" data-mp="2p5v7im3wad7t">
            <strong className="font-semibold uppercase tracking-wide" data-id="element-127" data-mp="2p38ysj59pro0">Oferta de relanzamiento:</strong>{' '}
            El Pack «Profe de Trail» con {offer.discountLabel.replace(' OFF', '')} de descuento solo por las próximas 24 horas o hasta agotar {offer.spots} cupos.
          </span>
        </p>
        <div className="flex shrink-0 items-center gap-1.5 font-display text-xl font-bold tabular-nums" data-id="element-128" data-mp="2b86nthlkdc4c">
          <span className="rounded bg-black/25 px-2 py-0.5" data-id="element-129" data-mp="1wo0xeghm3mdv">{hours}</span>
          <span aria-hidden="true" className="opacity-60" data-id="element-130" data-mp="1wpc2qkqph273">:</span>
          <span className="rounded bg-black/25 px-2 py-0.5" data-id="element-131" data-mp="1i0634vnyh9yo">{minutes}</span>
          <span aria-hidden="true" className="opacity-60" data-id="element-132" data-mp="1mxofyx53g9by">:</span>
          <span className="rounded bg-black/25 px-2 py-0.5" data-id="element-133" data-mp="1mw4w6wk8bg5f">{seconds}</span>
        </div>
      </div>
    </div>;
}